export default __webpack_public_path__ + "static/media/AMZN.228eed85.svg";